// extracted by mini-css-extract-plugin
export default {"cropContainer":"imageCrop_cropContainer__lp3Hs","labelContainer":"imageCrop_labelContainer__agBvO"};